import * as React from 'react';
require('./style.css');

interface IProps {
	onClick: () => void;
	children?: any;
}

/**
 *
 * @param props
 */
export const AddSectionButton = (props: IProps) => {
	return (
		<div className="addButtonSection">
			<button type="button" onClick={props.onClick}>
				<img src={require('containers/Html/icons/plus.svg')} className="icon" />
				{props.children}
			</button>
		</div>
	);
};
